module.exports = __webpack_public_path__ + "img/qrcode_yggzh.98453594.jpeg";